import i18n from '../../../../locales/index'
import { filter } from 'lodash';
import { hasPermission } from '../../../../libs/util';

export default {
  props: {
    parentItem: {
      type: Object,
      default: () => { }
    },
    theme: String,
    iconSize: Number
  },
  computed: {
    parentName () {
      return this.parentItem.name
    },
    children () {
      return filter(this.parentItem.children, item => {
        if (item.visible === false) return false
        if (item.requirePermission) {
          return hasPermission(item.requirePermission)
        }
        return true;
      });
    },
    textColor () {
      return this.theme === 'dark' ? '#fff' : '#495060'
    }
  }
}
